export const EMPLOYEE_LOG_REPORT = "EMPLOYEE_LOG_REPORT";
export const EMPLOYEE_LOG_REPORT_SUCCESS = "EMPLOYEE_LOG_REPORT_SUCCESS";
export const EMPLOYEE_LOG_REPORT_ERROR = "EMPLOYEE_LOG_REPORT_ERROR";

export const GET_EMPLOYEE_LOG_LIVE = "GET_EMPLOYEE_LOG_LIVE";
export const GET_EMPLOYEE_LOG_LIVE_SUCCESS = "GET_EMPLOYEE_LOG_LIVE_SUCCESS";
export const GET_EMPLOYEE_LOG_LIVE_ERROR = "GET_EMPLOYEE_LOG_LIVE_ERROR";

export const GET_VISITOR_LOG_LIVE = "GET_VISITOR_LOG_LIVE";
export const GET_VISITOR_LOG_LIVE_SUCCESS = "GET_VISITOR_LOG_LIVE_SUCCESS";
export const GET_VISITOR_LOG_LIVE_ERROR = "GET_VISITOR_LOG_LIVE_ERROR";

export const ADD_EMPLOYEE_LOG_LIVE = "ADD_EMPLOYEE_LOG_LIVE";

export const PEOPLE_COUNT_LOG_REPORT = "PEOPLE_COUNT_LOG_REPORT";
export const PEOPLE_COUNT_LOG_REPORT_SUCCESS =
  "PEOPLE_COUNT_LOG_REPORT_SUCCESS";
export const PEOPLE_COUNT_LOG_REPORT_ERROR = "PEOPLE_COUNT_LOG_REPORT_ERROR";

export const PEOPLE_TRACK_LOG_REPORT = "PEOPLE_TRACK_LOG_REPORT";
export const PEOPLE_TRACK_LOG_REPORT_SUCCESS =
  "PEOPLE_TRACK_LOG_REPORT_SUCCESS";
export const PEOPLE_TRACK_LOG_REPORT_ERROR = "PEOPLE_TRACK_LOG_REPORT_ERROR";

export const PEOPLE_COUNT_DASH = "PEOPLE_COUNT_DASH";
export const PEOPLE_COUNT_DASH_SUCCESS = "PEOPLE_COUNT_DASH_SUCCESS";
export const PEOPLE_COUNT_DASH_ERROR = "PEOPLE_COUNT_DASH_ERROR";

export const PEOPLE_COUNT_DASH_ADD = "PEOPLE_COUNT_DASH_ADD";

export const VEHICLE_COUNT_LOG_REPORT = "VEHICLE_COUNT_LOG_REPORT";
export const VEHICLE_COUNT_LOG_REPORT_SUCCESS =
  "VEHICLE_COUNT_LOG_REPORT_SUCCESS";
export const VEHICLE_COUNT_LOG_REPORT_ERROR = "PEOPLE_COUNT_LOG_REPORT_ERROR";

export const VEHICLE_COUNT_DASH = "VEHICLE_COUNT_DASH";
export const VEHICLE_COUNT_DASH_SUCCESS = "VEHICLE_COUNT_DASH_SUCCESS";
export const VEHICLE_COUNT_DASH_ERROR = "VEHICLE_COUNT_DASH_ERROR";

export const VEHICLE_COUNT_DASH_ADD = "VEHICLE_COUNT_DASH_ADD";

export const PEOPLE_OCCUPANCY_LOG_REPORT = "PEOPLE_OCCUPANCY_LOG_REPORT";
export const PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS =
  "PEOPLE_OCCUPANCY_LOG_REPORT_SUCCESS";
export const PEOPLE_OCCUPANCY_LOG_REPORT_ERROR =
  "PEOPLE_OCCUPANCY_LOG_REPORT_ERROR";

export const PEOPLE_OCCUPANCY_DASH = "PEOPLE_OCCUPANCY_DASH";
export const PEOPLE_OCCUPANCY_DASH_SUCCESS = "PEOPLE_OCCUPANCY_DASH_SUCCESS";
export const PEOPLE_OCCUPANCY_DASH_ERROR = "PEOPLE_OCCUPANCY_DASH_ERROR";

export const AGE_GENDER_LOG_REPORT = "AGE_GENDER_LOG_REPORt";
export const AGE_GENDER_LOG_REPORT_SUCCESS = "AGE_GENDER_LOG_REPORT_SUCCESS";
export const AGE_GENDER_LOG_REPORT_ERROR = "AGE_GENDER_LOG_REPORT_ERROR";

export const AGE_GENDER_DASH = "AGE_GENDER_DASH";
export const AGE_GENDER_DASH_SUCCESS = "AGE_GENDER_DASH_SUCCESS";
export const AGE_GENDER_DASH_ERROR = "AGE_GENDER_DASH_ERROR";

export const ADD_ANPR_LOG_LIVE = "ADD_ANPR_LOG_LIVE";

export const ANPR_REPORT = "ANPR_REPORT";
export const ANPR_REPORT_SUCCESS = "ANPR_REPORT_SUCCESS";
export const ANPR_REPORT_ERROR = "ANPR_REPORT_ERROR";

export const ADD_ANPR_REPORT = "ADD_ANPR_REPORT";
export const ADD_ANPR_REPORT_SUCCESS = "ADD_ANPR_REPORT_SUCCESS";
export const ADD_ANPR_REPORT_ERROR = "ADD_ANPR_REPORT_ERROR";

export const UPDATE_ANPR_REPORT = "UPDATE_ANPR_REPORT";
export const UPDATE_ANPR_REPORT_SUCCESS = "UPDATE_ANPR_REPORT_SUCCESS";
export const UPDATE_ANPR_REPORT_ERROR = "UPDATE_ANPR_REPORT_ERROR";

export const ANPR_LIVE_REPORT = "ANPR_LIVE_REPORT";
export const ANPR_LIVE_REPORT_SUCCESS = "ANPR_LIVE_REPORT_SUCCESS";
export const ANPR_LIVE_REPORT_ERROR = "ANPR_LIVE_REPORT_ERROR";

export const ANPR_SEARCH_REPORT = "ANPR_SEARCH_REPORT";
export const ANPR_SEARCH_REPORT_SUCCESS = "ANPR_SEARCH_REPORT_SUCCESS";
export const ANPR_SEARCH_REPORT_ERROR = "ANPR_SEARCH_REPORT_ERROR";

export const VEHICLE_LIVE_PARKING = "VEHICLE_LIVE_PARKING";
export const VEHICLE_LIVE_PARKING_SUCCESS = "VEHICLE_LIVE_PARKING_SUCCESS";
export const VEHICLE_LIVE_PARKING_ERROR = "VEHICLE_LIVE_PARKING_ERROR";

export const ANPR_DASH = "ANPR_DASH";
export const ANPR_DASH_SUCCESS = "ANPR_DASH_SUCCESS";
export const ANPR_DASH_ERROR = "ANPR_DASH_ERROR";

export const PARKING_LOG_REPORT = "PARKING_LOG_REPORT";
export const PARKING_LOG_REPORT_SUCCESS = "PARKING_LOG_REPORT_SUCCESS";
export const PARKING_LOG_REPORT_ERROR = "PARKING_LOG_REPORT_ERROR";

export const PARKING_DASH = "PARKING_DASH";
export const PARKING_DASH_SUCCESS = "PARKING_DASH_SUCCESS";
export const PARKING_DASH_ERROR = "PARKING_DASH_ERROR";

export const COMPLIANCE_ALERT_ADD = "COMPLIANCE_ALERT_ADD";

export const COMPLIANCE_ALERT_LIVE_RECENT = "COMPLIANCE_ALERT_LIVE_RECENT";
export const COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS =
  "COMPLIANCE_ALERT_LIVE_RECENT_SUCCESS";
export const COMPLIANCE_ALERT_LIVE_RECENT_ERROR =
  "COMPLIANCE_ALERT_LIVE_RECENT_ERROR";
export const COMPLIANCE_ALERT_REPORT = "COMPLIANCE_ALERT_REPORT";
export const COMPLIANCE_ALERT_REPORT_SUCCESS =
  "COMPLIANCE_ALERT_REPORT_SUCCESS";
export const COMPLIANCE_ALERT_REPORT_ERROR = "COMPLIANCE_ALERT_REPORT_ERROR";

export const COMPLIANCE_ALERT_DASH = "COMPLIANCE_ALERT_DASH";
export const COMPLIANCE_ALERT_DASH_SUCCESS = "COMPLIANCE_ALERT_DASH_SUCCESS";
export const COMPLIANCE_ALERT_DASH_ERROR = "COMPLIANCE_ALERT_DASH_ERROR";

export const LIGHTING_LOG_REPORT = "LIGHTING_LOG_REPORT";
export const LIGHTING_LOG_REPORT_SUCCESS = "LIGHTING_LOG_REPORT_SUCCESS";
export const LIGHTING_LOG_REPORT_ERROR = "LIGHTING_LOG_REPORT_ERROR";

export const LIGHTING_DASH = "LIGHTING_DASH";
export const LIGHTING_DASH_SUCCESS = "LIGHTING_DASH_SUCCESS";
export const LIGHTING_DASH_ERROR = "LIGHTING_DASH_ERROR";

export const FACILITY_ALERT_REPORT = "FACILITY_ALERT_REPORT";
export const FACILITY_ALERT_REPORT_SUCCESS = "FACILITY_ALERT_REPORT_SUCCESS";
export const FACILITY_ALERT_REPORT_ERROR = "FACILITY_ALERT_REPORT_ERROR";

export const LOG_REPORT_ERROR = "LOG_REPORT_ERROR";

export const ADD_COMPLIANCE_LOG_CHECK = "ADD_COMPLIANCE_LOG_CHECK";
export const COMPLIANCE_LOG_CHECK_RECENT = "COMPLIANCE_LOG_CHECK_RECENT";
export const COMPLIANCE_LOG_CHECK_RECENT_SUCCESS =
  "COMPLIANCE_LOG_CHECK_RECENT_SUCCESS";
export const COMPLIANCE_LOG_CHECK_RECENT_ERROR =
  "COMPLIANCE_LOG_CHECK_RECENT_ERROR";

export const COMPLIANCE_MASK_APPROVE = "COMPLIANCE_MASK_APPROVE";
export const COMPLIANCE_MASK_APPROVE_SUCCESS =
  "COMPLIANCE_MASK_APPROVE_SUCCESS";
export const COMPLIANCE_MASK_APPROVE_ERROR = "COMPLIANCE_MASK_APPROVE_ERROR";

export const COMPLIANCE_ALERT_UPDATE = "COMPLIANCE_ALERT_UPDATE";
export const COMPLIANCE_ALERT_UPDATE_SUCCESS =
  "COMPLIANCE_ALERT_UPDATE_SUCCESS";
export const COMPLIANCE_ALERT_UPDATE_ERROR = "COMPLIANCE_ALERT_UPDATE_ERROR";
